
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiEnergyElectricGoogle as ObiEnergyElectricGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-energy-electric-google.js';
 
 
 

 
 export const ObiEnergyElectricGoogle = createComponent({
   react: React,
   tagName: 'obi-energy-electric-google',
   elementClass: ObiEnergyElectricGoogleElement,
   events: {
     
   }
  });
 
 